import { QUERY_GET_WORKSHOP_SEARCH} from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getWorkshopSearch = baseThunk("workshopSearch/getWorkshopSearch", QUERY_GET_WORKSHOP_SEARCH, "POST")
